import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>

<blockquote>
  A breadcrumb trail allows the user to keep track and maintain awareness of their location within the Tes website.
</blockquote>

<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`NOTE: Jan 2019: This component is not acting according to this spec (see `}<MDXTag name="a" components={components} parentName="strong" props={{"href":"https://github.com/tes/frontend/issues/114"}}>{`this ticket`}</MDXTag>{` and `}<MDXTag name="a" components={components} parentName="strong" props={{"href":"https://github.com/tes/app-styleguide/issues/14"}}>{`this ticket`}</MDXTag>{`)`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`On the B2C website the first link in the breadcrumb trail is replaced with the  tds-home  icon. This must always point to the root (`}<MDXTag name="a" components={components} parentName="p" props={{"href":"http://tes.com/"}}>{`http://tes.com/`}</MDXTag>{`).`}</MDXTag>
<MDXTag name="p" components={components}>{`On Portal pages the name of the home link should be displayed rather than the icon.`}</MDXTag>
<MDXTag name="p" components={components}>{`If the trail exceeds the width afforded to it, the longer items in the trail will be truncated with a typographical ellipse (`}<code className="language-text">…</code>
{` / `}<code className="language-text">&amp;#8230;</code>
{` ), but not the current item (see below).`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`Full:`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`Root > great-great-grandparent > great-grandparent > grand-parent > parent > child`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`Truncated:`}</MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`Root > great-great-g... > great-grandparent > grand-parent > parent > child`}</MDXTag>
<MDXTag name="p" components={components}>{`There are three variations:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Light within a container `}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Light without a container`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Dark with white writing (inverse)`}</MDXTag>
</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  